import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { apparatusList, benefitBadges } from '../../data/keyBenefits';
export function KeyBenefits() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-133" data-mp="1vuizo82zi8eh">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-134" data-mp="1vsy7uq8213kb">
        <SectionTag icon="📚" tone="accent" data-id="element-135" data-mp="1qx0umss38dbr">
          515 páginas entre tomos y bonos
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-136" data-mp="2oietn5165m7k">
          240 fichas de ejercicios, preparaciones y variantes
        </h2>
        <p className="mt-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-137" data-mp="2ekr02ifaukqz">
          Suelo, Reformer, Cadillac, Silla, accesorios y pared — con opciones para simplificar y
          progresar según el control observado.
        </p>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-2" data-id="element-138" data-mp="137y8p8qf7ybg">
          {apparatusList.map(item => <span key={item} className="rounded-full border border-gold/40 bg-gold/10 px-4 py-1.5 text-sm font-medium text-primary" data-id="element-139" data-mp="y9n0t3jorxvv">
              {item}
            </span>)}
        </div>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-4 px-4 sm:grid-cols-3 sm:px-6" data-id="element-140" data-mp="3j37fll6u8vb6">
        {benefitBadges.map((badge, i) => <m.div key={badge.title} initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.08
      }} className="flex flex-col items-start gap-3 rounded-2xl border border-primary/10 bg-paper p-5 shadow-card-light" data-id="element-141" data-mp="3o1hcq1c4i5zf" data-mpi={i}>
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary/10" data-id="element-142" data-mp="35dm22qbt58aj">
              <badge.icon size={20} className="text-primary" data-id="element-143" data-mp="2recmnsvfei7m" />
            </div>
            <div data-id="element-144" data-mp="2vewk6xjwvnua">
              <p className="font-heading text-sm font-semibold text-primary" data-id="element-145" data-mp="2vdd354qfl8rg">{badge.title}</p>
              <p className="mt-1 text-sm leading-relaxed text-ink/80" data-id="element-146" data-mp="11wz69206zq8i">{badge.text}</p>
            </div>
          </m.div>)}
      </div>
    </section>;
}